export const CHANGE_MESSAGES_WINDOW_STATE = 'CHANGE_MESSAGES_WINDOW_STATE';
export const SET_NEW_CLIENT_MESSAGES = 'SET_NEW_CLIENT_MESSAGES';
export const SET_NEW_PRACTICE_MESSAGES = 'SET_NEW_PRACTICE_MESSAGES';
export const SET_DELETED_CLIENT_MESSAGES = 'SET_DELETED_CLIENT_MESSAGES';
export const SET_DELETED_PRACTICE_MESSAGES = 'SET_DELETED_PRACTICE_MESSAGES';
